import { useTranslation } from 'react-i18next';

import { DistributionRateData, InterestsData } from '@/api';
import { FamilleCardReprendreSouscription } from '@/components/Dico';
import { TrendingValue } from '@/components/TrendingValue/TrendingValue';
import { CONTRACT_FAMILY } from '@/enums/contractFamily';
import { CONTRACT_STATUS } from '@/enums/contractStatus';

import styles from './styles.module.css';

type Props = {
  family: string | null | undefined;
  insuranceLogo: string;
  contractName?: string | null | undefined;
  amount?: number | null | undefined;
  performance: number | null;
  gainLoss: number | null;
  interests?: InterestsData | null | undefined;
  distributionRate?: DistributionRateData | null;
  status?: string | null | undefined;
  manager?: string | null | undefined;
  onClick?: () => void;
};

const CardProduct = ({
  family,
  insuranceLogo,
  contractName,
  amount,
  performance,
  gainLoss,
  interests,
  distributionRate,
  status,
  manager,
  onClick,
}: Props) => {
  const { t } = useTranslation();

  let controlPlusLessInterest = '';
  let controlNumberInterets;
  if (interests) {
    controlPlusLessInterest = (interests?.interetsNet ?? 0) >= 0 ? styles.positiveInterest : styles.negativeInterest;
    controlNumberInterets =
      (interests?.interetsNet ?? 0) >= 0
        ? '+ ' + t('format.currencyFlexible', { value: interests?.interetsNet ?? 0 })
        : t('format.currencyFlexible', { value: interests?.interetsNet ?? 0 });
  }

  return (
    <button className={styles.card} onClick={onClick}>
      <div className={styles.cardHeader}>
        <span className={styles.familyLabel}>
          {FamilleCardReprendreSouscription[family as keyof typeof FamilleCardReprendreSouscription]}
        </span>
        <div>
          {family === CONTRACT_FAMILY.ASSURANCEVIE ||
          family === CONTRACT_FAMILY.RETRAITE ||
          family === CONTRACT_FAMILY.LIVRET ? (
            <div
              className={styles.insuranceLogo}
              style={{
                width: 71,
                height: 24,
                backgroundImage: `url("${insuranceLogo}")`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
              }}
            ></div>
          ) : (
            <h5>{manager}</h5>
          )}
        </div>
      </div>

      <div className={styles.cardBody}>
        <p className={styles.contractName}>{contractName}</p>
        <span className={styles.inProgressValuation}>
          {amount === null ? t('common.infoUnavailable') : t('format.currencyFlexible', { value: amount })}
        </span>

        {family !== CONTRACT_FAMILY.IMMOBILIER && (
          <TrendingValue value={gainLoss} secondaryValue={performance} icon={gainLoss !== null} />
        )}
        {family === CONTRACT_FAMILY.DEFISCALISATION && (
          <div className={styles.bottomInfo}>
            {status === CONTRACT_STATUS.LIQUIDATION && (
              <p className={styles.statusInProgress}>
                <span>En liquidation</span>
                <i className="totem-icon totem-icon-synchronisation liquidation" />
              </p>
            )}
          </div>
        )}
        {interests?.interetsNet !== null && interests != null && (
          <p className={styles.bottomDetails}>
            Intérêts à venir : <span className={controlPlusLessInterest}>{controlNumberInterets}</span>{' '}
          </p>
        )}
        {distributionRate?.pourcentage != null && (
          <p className={styles.bottomDetails}>
            Taux de distribution :{' '}
            <span className={styles.distributionRate}>
              {t('format.percentFlexible', { value: distributionRate.pourcentage ?? 0 })}
            </span>{' '}
            (en {distributionRate.anneeRef}){' '}
          </p>
        )}
      </div>
    </button>
  );
};

export default CardProduct;
